import { NotificationInstance } from 'antd/es/notification/interface';
import { ArgsProps } from 'antd/lib/notification';
import { TFunction } from 'react-i18next';

import { toastStore, TToast } from 'shared/model/toast';

import { getToastDuration } from './getToastDuration';

export const mapToast = (
  toastInstance: NotificationInstance,
  toast: Omit<TToast, 'method'>,
  t: TFunction,
): ArgsProps => {
  const {
    type,
    message: rawMessage,
    description: rawDescription,
    onClose: onCloseRaw,
    duration = getToastDuration(type),
    btn: btnRaw,
    ...config
  } = toast;

  const message = Array.isArray(rawMessage) ? t(...rawMessage) : t(rawMessage ?? '');
  const description = Array.isArray(rawDescription) ? t(...rawDescription) : t(rawDescription ?? '');

  const onClose = (): void => {
    onCloseRaw?.();
    toastStore.getState().closeToasts(type, toast.key);
  };

  const btn = typeof btnRaw === 'function' ? btnRaw(toastInstance) : btnRaw;

  return {
    message,
    description,
    onClose,
    duration,
    btn,
    ...config,
  };
};
